import { useSelector } from 'store/utils';

const useHasAppliedFilters = (): boolean => {
    const appliedFiltersCount = useSelector((state) => state.dashboard.appliedFiltersCount);
    return appliedFiltersCount > 0;
};

export default useHasAppliedFilters;
